/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import { RestrictionsTable } from "./RestrictionsTable";
import { StatesTable } from "./StateAccessTable";
import ClassNames from "Helpers/Common";

export const VisitAccess = ({ searchQuery }) => {
  const [activeTab, setActiveTab] = useState("all"); // "all" | "state"
  return (
    <div className="p-4 sm:p-6 bg-gray-50 min-h-screen">
      {/* --- Page Title --- */}
      <h6 className="text-sm sm:text-base font-medium text-gray-500 mb-6">
        Configure who can see patients by global policy, state, specialty, visit type, or consult flow.
      </h6>

      {/* --- Tabs + Global Restriction Toggle --- */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3 sm:gap-4 mb-6">
        {/* Tabs */}
        <div className="flex justify-center sm:justify-start bg-gray-100 rounded-lg p-1 w-full sm:w-auto">
          <button
            onClick={() => setActiveTab("all")}
            className={ClassNames(
              "flex-1 sm:flex-none text-center px-4 py-2 text-sm font-medium rounded-md focus:outline-none transition",
              activeTab === "all" ? "bg-white text-gray-900 shadow" : "text-gray-600 hover:text-gray-800"
            )}
          >
            All Doctors
          </button>
          <button
            onClick={() => setActiveTab("state")}
            className={ClassNames(
              "flex-1 sm:flex-none text-center px-4 py-2 text-sm font-medium rounded-md focus:outline-none ml-2 transition",
              activeTab === "state" ? "bg-white text-gray-900 shadow" : "text-gray-600 hover:text-gray-800"
            )}
          >
            By State
          </button>
        </div>

        {/* Global Restriction */}
        {/* <div className="flex justify-between sm:justify-end items-center bg-white border border-gray-200 rounded-lg px-4 py-3 shadow-sm w-full sm:w-auto">
          <div className="mr-3 text-sm">
            <div className="font-medium text-gray-800">Global Restriction</div>
            <div className="text-xs text-gray-500">Restrict all non-founders from seeing patients</div>
          </div>
          <Toggle enabled={!globalRestriction} onChange={() => setGlobalRestriction((prev) => !prev)} />
        </div> */}
      </div>
      {/* --- Table Section (responsive scroll) --- */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-100 overflow-x-auto ">
        <div className="min-w-[700px]">
          {activeTab === "all" ? <RestrictionsTable searchedProvider={searchQuery} /> : <StatesTable searchedProvider={searchQuery} />}
        </div>
      </div>
    </div>
  );
};
